import { Alert, Button, Card, Conditional } from '@payaca/ambrosia';

import ShadowDomRenderer from '@payaca/components/shadowDomRenderer/ShadowDomRenderer';
import UntitledIcon from '@payaca/untitled-icons';
import { FC } from 'react';

export const EmailTemplatePreview: FC<{
  template: string;
  onRemove?: () => void;
  onDownload?: () => void;
}> = ({ template, onRemove, onDownload }) => {
  return (
    <>
      <Alert colour="yellow">
        Please note that the data populated here is{' '}
        <b>not real and is only for preview purposes</b>.
      </Alert>

      <Card sizeVariant="lg" className="overflow-hidden relative mt-4">
        <Conditional condition={!!onRemove || !!onDownload}>
          <div className="absolute right-2 top-2 flex gap-2">
            {onDownload && (
              <Button
                onClick={onDownload}
                variant={'white'}
                shape={'pill'}
                size={'sm'}
                aria-label="Download template"
              >
                <UntitledIcon className="h-4 w-4" name="download-01.3" />
              </Button>
            )}
            {onRemove && (
              <Button
                onClick={onRemove}
                variant={'white'}
                shape={'pill'}
                size={'sm'}
                aria-label="Remove template"
              >
                <UntitledIcon className="h-4 w-3" name="x-close" />
              </Button>
            )}
          </div>
        </Conditional>

        <ShadowDomRenderer html={template} />
      </Card>
    </>
  );
};
